/**
 * Enum for cursor type
 * @readonly
 * @enum {string}
 */
const types = Object.freeze({
	DEFAULT: 'default',
	POINTER: 'pointer',
	NS_RESIZE: 'ns-resize',
	CROSSHAIR: 'cross',
	CLOSED_HAND: 'closed_hand'
});

export {
	types
};

/**
 * Enums associated with the cursor
 * @readonly
 * @enum {object}
 */
export default {
	types
};
